import {mapState} from "vuex";

Vue.component('CatUxoAppHeader', {
        data: function () {
            return {
                isProfileActive: false
            }
        },
        computed: {
            ...mapState('shared', {
                isMenuActive: state => state.isMenuActive,
                isDropdownOpen: state => state.isDropdownOpen,
            }),
        },
        methods: {
            toggleMenuState() {
                this.$store.dispatch('shared/toggleMenuState', {
                    value: !this.isMenuActive
                });

                this.toggleBodyClass();
            },
            toggleBodyClass() {
                let body = document.body;
                body.classList.toggle('has-overlay');
            },
            toggleDropdownState() {
                this.$store.dispatch('shared/toggleDropdownState', {
                    value: !this.isDropdownOpen
                })
            },
            toggleProfile() {
                this.isProfileActive = this.isProfileActive !== true;
            }
        },
});



// WEBPACK FOOTER //
// ./resources/js/components/shared/AppHeader.js